/* ==========================================================================
   Äylor — homepage behaviour (HYA, Sep 2026)
   - Product rails: arrow paging, disabled state at the ends, drag-free native
     scrolling on touch. Delegated so theme-editor re-renders keep working.
   - BareSculpt: click the play button to start the video, hide the poster.
   Quick Add and colour swatches are handled by aylor-collection.js.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__aylorHomeInit) return;
  window.__aylorHomeInit = true;

  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------------------------------------------------------- rails */
  function railOf(el) { return el.closest('[data-aylor-rail]'); }
  function trackOf(rail) { return rail ? rail.querySelector('[data-rail-track]') : null; }

  function syncNav(rail) {
    var track = trackOf(rail);
    if (!track) return;
    var prev = rail.querySelector('[data-rail-prev]');
    var next = rail.querySelector('[data-rail-next]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  function page(rail, dir) {
    var track = trackOf(rail);
    if (!track) return;
    var item = track.querySelector('.aylor-rail__item');
    var step = item ? item.getBoundingClientRect().width + 14 : track.clientWidth * 0.8;
    var count = Math.max(1, Math.floor(track.clientWidth / step));
    var before = track.scrollLeft;
    var delta = dir * step * count;
    track.scrollBy({ left: delta, behavior: 'smooth' });
    // Fallback for when a smooth scroll cannot animate (background tab, some
    // reduced-motion setups): jump to the same place instead of doing nothing.
    window.setTimeout(function () {
      if (Math.abs(track.scrollLeft - before) >= 2) return;
      var prior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = before + delta;
      track.style.scrollBehavior = prior;
    }, 320);
    // Scroll events are not guaranteed (hidden tab), so refresh the arrows here too.
    window.setTimeout(function () { syncNav(rail); }, 420);
  }

  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-rail-prev]');
    if (prev) { e.preventDefault(); page(railOf(prev), -1); return; }
    var next = e.target.closest('[data-rail-next]');
    if (next) { e.preventDefault(); page(railOf(next), 1); return; }
  });

  document.addEventListener('scroll', function (e) {
    var track = e.target && e.target.closest ? e.target.closest('[data-rail-track]') : null;
    if (track) syncNav(railOf(track));
  }, true);

  function initRails() {
    qsa('[data-aylor-rail]').forEach(function (rail) { syncNav(rail); });
    qsa('[data-aylor-cats]').forEach(function (root) { syncDots(root); });
    setupAutoplay();
    qsa('[data-ay-autoslide]').forEach(autoSlide);
  }

  /* ------------------------------------------------------- category dots */
  function syncDots(root) {
    var track = root.querySelector("[data-cats-track]");
    var dots = root.querySelectorAll("[data-cats-dots] .aylor-cats__dot");
    if (!track || !dots.length) return;
    var tile = track.querySelector(".aylor-cat");
    var step = tile ? tile.getBoundingClientRect().width + 12 : track.clientWidth;
    var i = Math.min(dots.length - 1, Math.round(track.scrollLeft / Math.max(step, 1)));
    for (var d = 0; d < dots.length; d++) dots[d].classList.toggle("is-active", d === i);
  }

  document.addEventListener("scroll", function (e) {
    var t = e.target && e.target.closest ? e.target.closest("[data-cats-track]") : null;
    if (t) syncDots(t.closest("[data-aylor-cats]"));
  }, true);

  /* ----------------------------------------------- auto-advancing carousels */
  function autoSlide(track) {
    if (track.getAttribute('data-ay-slide-init')) return;
    var interval = parseInt(track.getAttribute('data-ay-autoslide'), 10) || 0;
    if (!interval) return;
    track.setAttribute('data-ay-slide-init', '1');

    var paused = false, resumeTimer = null, inView = true;

    function hold() {
      paused = true;
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(function () { paused = false; }, Math.max(interval * 2, 8000));
    }
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      track.addEventListener(ev, hold, { passive: true });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { inView = entry.isIntersecting; });
      }, { threshold: 0.4 }).observe(track);
    }

    window.setInterval(function () {
      if (paused || !inView || document.hidden) return;
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      var kids = track.children;
      if (kids.length < 2) return;
      var a0 = kids[0].getBoundingClientRect(), a1 = kids[1].getBoundingClientRect();
      var step = a1.left - a0.left;
      if (step < 1) return;
      var next = (Math.round(track.scrollLeft / step) + 1) % kids.length;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: next * step, behavior: reduce ? 'auto' : 'smooth' });
    }, interval);
  }

  /* ------------------------------------------------- autoplay when in view */

  /* HYA 23 Sep 2026 - "this video should be playing on a loop" (mobile).
     The BareSculpt video_tag was rendered without playsinline, and iOS will
     not autoplay a video inline without it - it simply shows the poster and
     waits for a fullscreen tap. Every video in an autoplaying media block is
     now given playsinline, muted and loop as PROPERTIES (which iOS reads at
     play() time) as well as attributes, before the first play() is tried. */
  function primeForMobile(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
  }

  function setupAutoplay() {
    qsa('[data-fabric-media].is-playing').forEach(function (media) {
      if (media.getAttribute('data-ay-auto')) return;
      var video = media.querySelector('video');
      if (!video) return;
      media.setAttribute('data-ay-auto', '1');
      primeForMobile(video);

      function tryPlay() {
        if (!video.paused) return;
        var p = video.play();
        if (p && typeof p.catch === 'function') {
          /* A refusal is not permanent - Low Power Mode, a backgrounded tab or
             a not-yet-buffered file all recover. Show the play button as the
             way back in rather than giving up on the loop for good. */
          p.catch(function () { media.classList.remove('is-playing'); });
        }
      }

      /* The first frames arriving, and the tab coming back to the front, are
         both moments a previously refused autoplay will be accepted. */
      video.addEventListener('loadeddata', tryPlay);
      video.addEventListener('canplay', tryPlay);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) tryPlay();
      });

      if (!('IntersectionObserver' in window)) { tryPlay(); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) tryPlay();
          else if (!video.paused) video.pause();
        });
      }, { threshold: 0.25, rootMargin: '200px 0px' }).observe(media);
    });
  }

  /* ---------------------------------------------------------------- video */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fabric-play]');
    if (!btn) return;
    e.preventDefault();
    var media = btn.closest('[data-fabric-media]');
    var video = media && media.querySelector('video');
    if (!video) return;
    media.classList.add('is-playing');
    /* HYA 23 Sep 2026 - this used to switch the browser's control bar on, which
       left a grey chrome strip across the bottom of the clip for good. The
       video is a silent background loop, so it keeps its own controls off. */
    primeForMobile(video);
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  });

  document.addEventListener('ended', function (e) {
    if (e.target && e.target.tagName === 'VIDEO') {
      var media = e.target.closest('[data-fabric-media]');
      if (media) media.classList.remove('is-playing');
    }
  }, true);

  /* ------------------------------------------------------------- lifecycle */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRails);
  } else {
    initRails();
  }
  window.addEventListener('resize', initRails);
  window.addEventListener('load', initRails);
  document.addEventListener('shopify:section:load', initRails);
  document.addEventListener('shopify:section:select', initRails);
})();
